module.exports = __webpack_public_path__ + "img/valtis-logo-blue.e6d07cdb.png";